<template>
    <div class="notification">
        <div class="notification-content">
            {{ content }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotificationComponent',
    props: {
        content: {
            type: String,
            required: false,
            default: ''
        }
    }
}
</script>

<style scoped>
.notification {
    background: #ffffffaa;
    border-radius: 9px;
    padding: 12px 16px;
    width: 100%;
    color: #404344;
    font-size: 14px;
    text-align: center;
    margin-bottom: 16px;
}
</style>
